import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './styles.module.scss';

class Spinner extends Component {
    render() {
        return(
            <div className={styles.spinnerContainer}>
                <CircularProgress/>
            </div>
        );
    }
}

export default Spinner;